import type { BranchTranslationEntity } from './BranchTranslationEntity'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { CategoryMiniEntity } from '@/features/category/domain/entities/CategoryMiniEntity'
import type { BranchShiftEntity } from './BranchShiftEntity'
import type { BranchStatus } from '../enums/BranchStatus'
import type { BrandEntity } from '@/features/brand/domain/entities/BrandEntity'
import type { BranchContactsEntity } from './BranchPContactsEntity'
import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { ServiceMiniEntity } from '@/features/service/domain/entities/ServiceMiniEntity'
import type { CreateUpdateBrandEntity } from '@/features/brand/domain/entities/CreateUpdateBrandEntity'
import type { OrderFulfillmentMethod } from '@/features/order/domain/enums/OrderFulfillmentMethod'
import type { SalesManEntity } from '@/features/salesMan/domain/entities/SalesManEntity'
import type { InterfaceType } from '../enums/InterfaceType'
import type { BranchTagsMiniEntity } from '@/features/branchTags/domain/entities/BranchTagsMiniEntity'
import type { BranchDeliverySettingMiniEntity } from '@/features/branchDeliverySetting/domain/entities/BranchDeliverySettingMiniEntity'
import type { BranchMinimumCartSystemMiniEntity } from '@/features/branchMinimumCartSystem/domain/entities/BranchMinimumCartSystemMiniEntity'

export class CreateUpdateBranchEntity {
  brand?: BrandEntity
  location?: {
    longitude: number
    latitude: number
  }
  translations?: Array<BranchTranslationEntity>
  users?: Array<UserMiniEntity>
  branchTags?: Array<BranchTagsMiniEntity>
  service?: ServiceMiniEntity
  categories?: Array<CategoryMiniEntity> | null
  branchShiftDays?: Array<BranchShiftEntity>
  manualStatus?: BranchStatus
  channel?: ChannelMiniEntity
  relatedChannels?: Array<ChannelMiniEntity> | null
  contacts?: BranchContactsEntity[]
  newBrand?: CreateUpdateBrandEntity
  fulfillmentMethods?: Array<OrderFulfillmentMethod>
  manualStatusExpiresAt?: string
  saleMan?: SalesManEntity
  interfaceType?: InterfaceType
  minimumCartAmountToOrder?: number | null
  minimumJetOrderAmountToOrder?: number
  disabled?: boolean
  skuPrefix?: string | null
  autoOrderApprovalPriceLimit?: number | null
  taxRatioPerOrder?: number | null
  commissionAmountPerOrder?: number | null
  commissionAmountPerJetOrder?: number | null
  mealCommissionAmount?: number | null
  outOfWorkingShift?: boolean
  branchDeliverySystems?: Array<BranchDeliverySettingMiniEntity> | null
  minimumCartSystem?: BranchMinimumCartSystemMiniEntity | null
  minDeliveryTime?: number
  maxDeliveryTime?: number
  zohoBooksVenderId?: string | null
  zohoBooksWarehouseId?: string | null
  hasMyMealSupport?: boolean
  autoAcceptMeals?: boolean
  scheduleOrderApprovalMinutes?: number | null
  allowOperatorItemAdd?: boolean
  allowOperatorItemEdit?: boolean
  allowOperatorItemPriceEdit?: boolean
  externalBranchId?: number
  isScheduledOrderSupported?: boolean
}
